module.exports = __webpack_public_path__ + "static/media/cloud-b-v3@2x.14fd760e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-b-v3@2x.png
// module id = 93
// module chunks = 0